import React from 'react'
import './index.scss'
import clsx from 'clsx'

interface IProps {
    firstName: string
    lastName: string
    small?: boolean
}

const AvatarComponent = ({ firstName, lastName, small = false }: IProps) => {
    const classNames = clsx('avatar-component', small && 'small')
    const avatar = `${firstName.substring(0, 1)}${lastName.substring(0, 1)}`

    return (
        <div className={classNames}>
            <span className="white-text">{avatar}</span>
        </div>
    )
}

export default AvatarComponent
